<div class="panel">
  <h2>Authentification</h2>

  <div class="form-group required">
    <label for="username">Nom d'utilisateur</label>
    <input id="username" type="text" placeholder="" [formControl]="username" maxlength="50"/>
    <span class="info info-error" [hidden]="username.valid || username.pristine || !username.errors.required">Ce champ est requis</span>
    <span class="info info-error" [hidden]="username.valid || username.pristine || !username.errors.email">Ce champ doit être un email</span>
  </div>

  <div class="form-group">
    <label for="password">Mot de passe</label>
    <div class="input-icon">
      <input id="password" [type]="passwordVisible ? 'text' : 'password'" placeholder="" [formControl]="password" maxlength="50" autocomplete="new-password"/>
      <div class="icons">
        <a class="icon-btn" (click)="generatePassword($event)" title="Générer un nouveau mot de passe">
          <t-icon name="flash_on"></t-icon>
        </a>

        <a class="icon-btn" (click)="togglePasswordVisibility()" title="Afficher/Cacher le mot de passe">
          <t-icon *ngIf="!passwordVisible" name="visibility"></t-icon>
          <t-icon *ngIf="passwordVisible" name="visibility_off"></t-icon>
        </a>
      </div>
    </div>
    <span class="info" [ngClass]="(password.pristine || !password.hasError('minlength')) ? '' : 'info-error'">Au moins 8 charactères</span>
  </div>

</div>